<template>
  <div class="confirm_require">
    <p class="require-title">以下を確認の上、チェックしてください。</p>
    <a-checkbox-group v-model="statusCheck" class="require-items">
      <div v-for="(option, index) in options" :key="index">
        <a-checkbox v-if="!option.link" :value="option.value" class="require-item">
          {{ option.label }}
          <span v-if="option.label1"><br>&emsp;&emsp;{{option.label1}}</span>
          <span v-if="option.label2" style="font-size: 12px;" ><br>&emsp;&emsp;{{option.label2}}</span>
        </a-checkbox
        >
        <a-checkbox :value="option.value" v-else class="require-item">
          <a :href="option.link" class="label-link" target="_blank">
            {{ option.label }}
            <i v-if="option.icon" class="ml-1 icon" :class="option.icon"></i
          ></a>
        </a-checkbox>
      </div>
    </a-checkbox-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusCheck: []
    }
  },
  computed: {
    options() {
      return [
        { label: '施設へ電話予約が完了している', value: '1' },
        { label: '1室2名様以上のご予約である', value: '2' },
      ]
    },
    isAcceptrequire() {
      return this.statusCheck.length === this.options.length
    }
  },
  watch: {
    isAcceptrequire: {
      handler(val) {
        this.$emit('change', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
